import React from 'react';
import styles from '../Specifications.module.scss';
import { Chip } from '@material-ui/core';

export default function SkillChip({ label }) {
  return (
    <Chip classes={{ label: styles.chip_label }} label={label || ''} className={styles.chip} />
  );
}
